module.exports = __webpack_public_path__ + "static/media/iridium.66326147.png";


//////////////////
// WEBPACK FOOTER
// ./src/static/iridium.png
// module id = 796
// module chunks = 0